@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.usecase.inspection

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.repository.InspectionRepository
import com.wintermar.inspection.feature.domain.repository.TemplateRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerFileRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerLocationRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerSelectionRepository
import kotlinx.coroutines.flow.Flow

actual class DeleteInspectionUseCaseImpl actual constructor(
    private val inspectionRepository: InspectionRepository,
    private val templateRepository: TemplateRepository,
    private val answerRepository: AnswerRepository,
    private val answerFileRepository: AnswerFileRepository,
    private val answerLocationRepository: AnswerLocationRepository,
    private val answerSelectionRepository: AnswerSelectionRepository
) : DeleteInspectionUseCase {
    actual override operator fun invoke(inspectionId: String, deleteLocalOnly: Boolean): Flow<FlowResult<Unit>> {
        return inspectionRepository.deleteInspectionById(id = inspectionId)
    }
}
